module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ApiPlt/tc-custom/9798892154741.jpg?1728724800017",
      "alt": "This image is the cover for the book Minor Arcana #1, Minor Arcana"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Minor Arcana #1, Minor Arcana\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Theresa, the daughter of a small-town “psychic” fraud, returns home to care for her ailing mother, however begrudgingly. But when Theresa discovers that there may be more to the magic than she originally believed, she’ll find herself caught up in a town that desperately needs her help… One of the most renowned creators in comics, New York Times bestselling and award-winning writer and artist Jeff Lemire (Descender, Black Hammer) arrives at BOOM! Studios with an extra-length opening chapter of a must-read ongoing series inspired by, and intricately linked to the tarot and perfect for fans of his creator-owned work as well as Helen of Wyndhorn and Locke& Key.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeff Lemire\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0